<div class="m-3" *ngIf="true">
    <div class="w-80">
        <label class="super-compos-label-input">Fusionner les documents avec le modèle :</label>
        <p-dropdown [options]="modelesDocPoint" [style]="{'width':'100%'}" optionLabel="description"
            [(ngModel)]="modele" [placeholder]="'selectModeles'|translate" appendTo="body" [showClear]="true"
            [filter]="true" [virtualScroll]="true" (onChange)="onSelectedModel()" [itemSize]="30">
        </p-dropdown>
    </div>

    <div class="mt-3">
        <p-accordion [multiple]="true">
            <p-accordionTab *ngIf="errorCount > 0" class="accordionError accordion-tab-max-height" [selected]="false"
                [header]="errorCount + ' ' + ('error.errors' | translate)">
                <span class="mb-0 red-text d-flex align-items-center">
                    <p [innerHTML]="errorMessage" class="break-word"></p>
                </span>
            </p-accordionTab>
            <p-accordionTab *ngIf="successCount > 0" class="accordionSucces accordion-tab-max-height" [selected]="true"
                [header]="successCount + ' ' + ('success.success' | translate)">
                <span class="mb-0 green-text d-flex align-items-center">
                    <p [innerHTML]="successMessage" class="break-word"></p>
                </span>
            </p-accordionTab>
        </p-accordion>
    </div>

    <p-footer class="d-flex align-items-center justify-content-end mt-3">
        <p class="alert alert-secondary alertBox" role="alert" *ngIf="modele && successCount > 1">Un document va être
            généré dans les fichiers de la séance avec tous les points sélectionnés pour le modèle de document choisi
        </p>
        <p class="alert alert-secondary alertBox" role="alert" *ngIf="modele && successCount === 1">Il faut au moins
            deux points en succès pour faire une fusion de document</p>
        <super-button [disabled]="!modele || successCount <= 1" styleClass="green"
            text="{{ 'iscan.actions.merge' | translate }}" (click)="mergeDoc()"></super-button>
    </p-footer>
</div>